import React from 'react';
import './timeLinestyle.css'
import secondsToHms from '../SecondsToHms/secondsToHms';
function TimLine(props) {
    const conditionalCalss = (e) => {
        return e.hasPassed ? 'completed-circle' : 'inprogress-circle'
    }
    return (
        <React.Fragment>
            <div>
                <div className="container-block">
                    <ul>
                        {
                            props.coreContent && props.coreContent.map((e) =>
                                <li key={e.id} ><span className={conditionalCalss(e)}></span>
                                    <div>
                                        <div className="title cp" onClick={() => props.playCourse(props.courseDetails.id, e.id)}>{e.name}</div>
                                        {/* <div className="type">Duration: {secondsToHms(e.duration)}</div> */}
                                        <div className="info">
                                            {/* <span className='bold'>Author:</span>
                                            <span>&nbsp;Jered Doe</span> */}
                                            {e.duration > 1 && <>
                                                <span className='bold'>Duration:</span>
                                                <span>&nbsp;{secondsToHms(e.duration)}</span>
                                            </>
                                            }

                                        </div>
                                    </div><span className="number"></span>
                                </li>)
                        }
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
}
export default TimLine;